const GRADER_JSON_MARKER = 'GRADER_JSON:';
const GRADER_JSON_LINE_RE = /^GRADER_JSON:.*(?:\r?\n|$)/gm;
const STDERR_MARKER = '\n--- STDERR ---';

function extractGraderPayload(text) {
  const idx = text.lastIndexOf(GRADER_JSON_MARKER);
  if (idx === -1) {
    return null;
  }

  const jsonText = text.slice(idx + GRADER_JSON_MARKER.length).trim();
  if (jsonText === '') {
    return null;
  }

  try {
    return JSON.parse(jsonText);
  } catch (_) {
    return null;
  }
}

/**
 * Remove harness grading channel from text shown in the output panel.
 *
 * @param {string|null|undefined} output
 * @returns {string}
 */
export function stripGraderChannelFromDisplay(output) {
  if (output === null || output === undefined) {
    return '';
  }

  let text = String(output);
  const markerIndex = text.indexOf(STDERR_MARKER);
  if (markerIndex !== -1) {
    text = text.slice(0, markerIndex);
  }

  return text.replace(GRADER_JSON_LINE_RE, '').replace(/\n{3,}/g, '\n\n').trimEnd();
}

/**
 * Parse a graded result from sandbox stdout or a backend JSON body.
 * Returns true/false when a definitive grade is found, otherwise null.
 *
 * @param {string|null|undefined} output
 * @returns {boolean|null}
 */
export function parseGraderResult(output) {
  if (output === null || output === undefined) {
    return null;
  }

  const text = String(output).trim();
  if (text === '') {
    return null;
  }

  if (text.startsWith('{')) {
    try {
      const payload = JSON.parse(text);
      if (typeof payload.passed === 'boolean') {
        return payload.passed;
      }
      if (typeof payload.ok === 'boolean') {
        return payload.ok;
      }
    } catch (_) {
      /* fall through to stdout parsing */
    }
  }

  const payload = extractGraderPayload(text);
  if (payload === null) {
    return null;
  }

  return payload.ok === true;
}
